import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import Select from 'react-select';
import useGetPurchasesQuotationList from '@hooks/PUR/PurchaseQuotation/useGetPurchasesQuotationList';
import NeatixModal from '@components/Modal/NeatixModal';
import PurchaseRequestList from '../PurchaseRequest/PurchaseRequestList';
import useGetPurchaseRequestList from '@hooks/PUR/PurchaseRequest/useGetPurchaseRequestList';
import QuotationComparison from './QuotationComparison';
import { Card, CardBody } from '@components/card/card';
import NtxTable from '@components/DataTable/NtxTable';
import confirmAction from '@components/Shared/Alert/confirmAction';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { DeletePurchaseQuotation } from '@store/purchases/PurchaseQuotation/purchaseQuotationSlice';
import { useAppDispatch } from '@store/hooks';
import { Can } from '@Permisstions/Can';

const Index = () => {
  const [show, setShow] = useState(false);
  const [PurchaseRequesId, setPurchaseRequesId] = useState<any>(null);

  const [Quotations, setQuotations] = useState<any>();
  const [show2, setShow2] = useState(false);

  const [search, setSearch] = useState('');

  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();
  const { PurchaseRequesOptions, loading: loading2, error: error2 } = useGetPurchaseRequestList();

  const { PurchaseQuotationList, loading, error } = useGetPurchasesQuotationList({
    PurchaseRequestId: PurchaseRequesId
  });

  const dispatch = useAppDispatch();

  const handleDeletePurchaseQuotation = async (id: string) => {
    const isConfirmed = await confirmAction('هل أنت متأكد من حذف عرض السعر');

    if (!isConfirmed) return;

    try {
      const result = await dispatch(DeletePurchaseQuotation(id)).unwrap();
      if (result?.succeeded) {
        CustomAlert({ action: 'Delete', msg: t('تم حذف عرض السعر بنجاح') });
      }
    } catch (e: any) {
      CustomAlert({ action: 'Error', msg: e?.message || t('فشل حذف عرض السعر') });
    }
  };

  const columns = [
    { title: t('Number'), key: 'code' },
    { title: t('Date'), key: 'date' },
    { title: t('Supplier'), key: 'suplere' },
    { title: t('Branch'), key: 'branch' },
    { title: t('Amount'), key: 'amount' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = PurchaseQuotationList?.map(item => {
    let rowClass;

    return {
      code: item.code,
      date: item.transactionDate?.toString()?.split('T')[0],
      suplere: i18n.language === 'en' ? item.peopleName : item.peopleName2,
      branch: i18n.language === 'en' ? item.organizationName : item.organizationName2,
      amount: item.grossAmount,
      action: (
        <>
          <button
            type='button'
            className='btn btn-sm btn-outline-danger mx-1'
            onClick={() => handleDeletePurchaseQuotation(item.id)}
          >
            <i className='fas fa-trash fa-lg'></i>
          </button>
          <Can permission={'PURViewQuotationDetails'}>
            <button
              type='button'
              className='btn btn-sm btn-outline-theme mx-1'
              onClick={() => Navigate(`${item.id}/UpdatePurchaseQuotation`)}
            >
              <i className='far fa-lg fa-fw fa-eye'></i>
            </button>
          </Can>
        </>
      )
    };
  });

  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'Quotations',
              link: null
            }
          ]}
          PageName='Quotations'
        />
        <div className='ms-auto'>
          <Can permission={'PURAddQuotation'}>
            <Link to='' className='btn me-1 btn-theme' onClick={() => setShow(true)}>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('NewQuotation')}
            </Link>
          </Can>
        </div>
      </div>

      <Card>
        <CardBody>
          <div className='row mb-1'>
            <div className='col-lg-4'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text fw-bold'>{t('Search')}</span>
                <div className='input-group'>
                  <div className='flex-fill position-relative'>
                    <div className='input-group border-0 '>
                      <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                        <i className='fa fa-search opacity-5 text-theme'></i>
                      </div>
                      <input
                        type='text'
                        autoComplete='off'
                        className='form-control ps-35px'
                        value={search}
                        onChange={e => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={PurchaseRequesId ? 'col-lg-6' : 'col-lg-8'}>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text  fw-bold'>{t('PurchaseRequest')}</span>
                <Select
                  classNamePrefix='react-select'
                  className={`w-100 `}
                  isLoading={loading2}
                  isSearchable={true}
                  isClearable
                  options={PurchaseRequesOptions}
                  value={PurchaseRequesOptions?.find(f => f.value === PurchaseRequesId)}
                  onChange={option => {
                    setPurchaseRequesId(option?.value);
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
            <div className='col-lg-2'>
              <Can permission={'PURCompareQuotes'}>
                <button
                  hidden={!PurchaseRequesId}
                  type='submit'
                  className='btn  me-1 btn-theme rounded-2 w-100'
                  onClick={() => {
                    setQuotations(PurchaseQuotationList);
                    setShow2(true);
                  }}
                >
                  <i className='fas fa-balance-scale me-2'></i>

                  {t('QuotationComparison')}
                </button>
              </Can>
            </div>
          </div>
          <Loading loading={loading} error={error} Type='Dots'>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
            />
          </Loading>
        </CardBody>
      </Card>

      <NeatixModal show={show} setShow={setShow} bodyClassName='p-0' size='lg' showHeader={false}>
        <PurchaseRequestList Route='Quotation' />
      </NeatixModal>

      <NeatixModal show={show2} setShow={setShow2} bodyClassName='p-0' size='xl' showHeader={false}>
        <Card>{Quotations && <QuotationComparison Quotations={Quotations} />}</Card>
      </NeatixModal>
    </div>
  );
};

export default Index;
